import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsApprovalStatus, PmsApprovalStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsApprovalStatus>
    useData={usePmsApprovalStatus}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
